<template>
  <KanbanView />
</template>

<script setup>
import KanbanView from './views/KanbanView.vue';
</script>

<style>
@import "ag-grid-community/styles/ag-grid.css";
@import "ag-grid-community/styles/ag-theme-alpine.css";
</style>
